import React from 'react';
import { Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChevronDown,
    faChevronUp,
    faCircleNotch,
    faMapMarker,
    faUserMinus,
} from '@fortawesome/free-solid-svg-icons';
import cls from 'classnames';
import { AppNavPaths } from '../AppNavPaths';
import CustomCircularProgress from '../common/CustomCircularProgress';
import { CountyLabel } from '../uscounties/CountyLabel';
import DispatchJobAssignments from './DispatchJobAssignments';
import JobNotesModalButton from './JobNotesModalButton';

class JobListingContainer extends React.Component {
    render() {
        const {
            jobSearchText,
            hideCancelledOrders,
            allJobsCollapsed,
            jobsLoading,
            displayedPlanningJobs,
            planningJobs,
            jobsOpened,
            jobsSaving,
            staff,
            equipment,
            equipmentGroups,
            selectedWeekRangeDays,
            tenantSettings,
            strings,
            handleJobSearchText,
            onHideCancelledOrdersChanged,
            onToggleAllJobsCollapsed,
            hasCancelledJobEntry,
            hasOnlyCancelledAssignmentEntries,
            toggleJobCollapse,
            getPlanningJobDisplayLocationName,
            onEquipmentAssignmentChange,
            onRemoveAssignment,
            onUpdateEquipmentAssignmentLinks,
            onRemoveDayJob,
            setCrewLead,
            onEditJobWorkflowClicked,
            onEmergencyClicked,
            onAssignmentFilterClicked,
        } = this.props;

    return (
                <div className="job-listing-container">
                    <div className="job-listing-container-header">
                        <span className="job-listing-container-subheader">
                            ORDERS
                        </span>
                        <div className="job-listing-filters w-75">
                            <Input
                                placeholder="Search Orders"
                                bsSize="sm"
                                type="search"
                                id="jobSearchText"
                                name="jobSearchText"
                                className="ml-auto"
                                value={
                                    jobSearchText ??
                                    ''
                                }
                                onChange={(
                                    e
                                ) =>
                                    handleJobSearchText(
                                        e
                                            .target
                                            .value
                                    )
                                }
                            />
                            <div className="ml-2 d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    id="hideCancelledOrders"
                                    name="hideCancelledOrders"
                                    checked={
                                        !!hideCancelledOrders
                                    }
                                    onChange={
                                        onHideCancelledOrdersChanged
                                    }
                                />
                                <label
                                    htmlFor="hideCancelledOrders"
                                    className="mb-0 ml-1"
                                >
                                    Hide
                                    Cancelled
                                </label>
                            </div>
                            <span
                                className="ml-2 btn btn-outline-primary btn-sm d-flex flex-row align-items-center"
                                title="Expand or collapse all orders."
                                onClick={() =>
                                    onToggleAllJobsCollapsed(
                                        displayedPlanningJobs.map((x) => x.id)
                                    )
                                }
                            >
                                <i
                                    className={cls(
                                        'fa fa-lg m-0 p-0',
                                        {
                                            'fa-chevron-down':
                                                !allJobsCollapsed,
                                            'fa-chevron-up':
                                                !!allJobsCollapsed,
                                        }
                                    )}
                                />
                            </span>
                        </div>
                    </div>
                    <div className="job-listing">
                        {!!jobsLoading && (
                            <CustomCircularProgress />
                        )}
        
                        {!jobsLoading &&
                            !!(
                                displayedPlanningJobs ??
                                []
                            ).length &&
                            displayedPlanningJobs.map(
                                (
                                    job,
                                    index
                                ) => {
                                    const jobPaneOpen =
                                        jobsOpened.includes(
                                            job.id
                                        );
                                    const isPartOfCancelledSet =
                                        hasCancelledJobEntry(
                                            job.id
                                        );
                                    const hasOnlyCancelledAssignments =
                                        hasOnlyCancelledAssignmentEntries(
                                            job.id
                                        );
        
                                    // let cancelled = selectedWeekRangeDays.every(x => job.assignments[x.getDay()].isCancelled === true);
                                    // if (!cancelled) {
                                    return (
                                        <div
                                            className={cls(
                                                'jobListItem',
                                                {
                                                    'details-open':
                                                        !!jobsOpened.includes(
                                                            job.id
                                                        ),
                                                    saving: !!jobsSaving.includes(
                                                        job.id
                                                    ),
                                                }
                                            )}
                                            key={
                                                job.id
                                            }
                                        >
                                            <div className="saving-progress">
                                                <FontAwesomeIcon
                                                    icon={
                                                        faCircleNotch
                                                    }
                                                    spin
                                                />
                                            </div>
                                            <div className="jobListItemHeader">
                                                <div className="flex-fill job-name">
                                                    {isPartOfCancelledSet && (
                                                        <span className="text-danger mr-1">
                                                            [CANCELLED]
                                                        </span>
                                                    )}
                                                    {hasOnlyCancelledAssignments && (
                                                        <span className="mr-1 text-info text-small">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faUserMinus
                                                                }
                                                            />
                                                        </span>
                                                    )}
                                                    {
                                                        job.name
                                                    }
                                                    {job.foremanName && (
                                                        <>
                                                            {' '}
                                                            {
                                                                job.foremanName
                                                            }
                                                        </>
                                                    )}{' '}
                                                    {
                                                        job.startTime
                                                    }
                                                    {job.workOrderNumber && (
                                                        <>
                                                            {' '}
                                                            {
                                                                job.workOrderNumber
                                                            }
                                                        </>
                                                    )}
                                                    {job.hasResourceOverrides && (
                                                        <>
                                                            *
                                                        </>
                                                    )}
                                                    <JobNotesModalButton
                                                        job={
                                                            job
                                                        }
                                                    />
                                                </div>
                                                <Link
                                                    className="job-number ml-1 mr-2 site-link"
                                                    to={
                                                        AppNavPaths.LongTermScheduleCalendar
                                                    }
                                                    target="_blank"
                                                >
                                                    {
                                                        job.number
                                                    }
                                                </Link>
                                                <FontAwesomeIcon
                                                    className="ml-2 cursor-pointer"
                                                    icon={
                                                        !jobPaneOpen
                                                            ? faChevronDown
                                                            : faChevronUp
                                                    }
                                                    title={
                                                        jobPaneOpen
                                                            ? 'HideDetails'
                                                            : 'Show Details'
                                                    }
                                                    onClick={() =>
                                                        toggleJobCollapse(
                                                            job.id,
                                                            !!jobPaneOpen
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div
                                                className="job-details"
                                                hidden={
                                                    !jobPaneOpen
                                                }
                                            >
                                                <div className="job-details-header">
                                                    <div className="d-flex flex-column flex-fill">
                                                        <span
                                                            className="job-address mb-1"
                                                            title="Meeting Location"
                                                        >
                                                            <span className="badge badge-secondary mr-1">
                                                                M
                                                            </span>
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faMapMarker
                                                                }
                                                                className="text-muted mr-1"
                                                            />
                                                            {job.meetingAddress ||
                                                                getPlanningJobDisplayLocationName(
                                                                    job
                                                                )}
                                                        </span>
                                                        <span
                                                            className="job-address"
                                                            title="Order Location"
                                                        >
                                                            <span className="badge badge-secondary mr-1">
                                                                J
                                                            </span>
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faMapMarker
                                                                }
                                                                className="text-muted mr-1"
                                                            />
                                                            {job.jobAddress ||
                                                                getPlanningJobDisplayLocationName(
                                                                    job
                                                                )}
                                                        </span>
        
                                                        {Boolean(
                                                            job.usCounty
                                                        ) && (
                                                            <span
                                                                className="job-address mt-1"
                                                                title="Order County"
                                                            >
                                                                <span className="badge badge-secondary mr-1">
                                                                    C
                                                                </span>
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faMapMarker
                                                                    }
                                                                    className="text-muted mr-1"
                                                                />
        
                                                                <CountyLabel
                                                                    {...job.usCounty}
                                                                />
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <DispatchJobAssignments
                                                    allStaff={
                                                        staff.rows
                                                    }
                                                    allEquipment={
                                                        equipment.rows
                                                    }
                                                    job={
                                                        job
                                                    }
                                                    jobIndex={planningJobs.indexOf(
                                                        job
                                                    )}
                                                    selectedWeekRangeDays={
                                                        selectedWeekRangeDays
                                                    }
                                                    onEquipmentAssignmentChange={
                                                        onEquipmentAssignmentChange
                                                    }
                                                    onRemoveAssignment={
                                                        onRemoveAssignment
                                                    }
                                                    onUpdateEquipmentAssignmentLinks={
                                                        onUpdateEquipmentAssignmentLinks
                                                    }
                                                    onRemoveDayJob={
                                                        onRemoveDayJob
                                                    }
                                                    setCrewLead={
                                                        setCrewLead
                                                    }
                                                    onEditJobWorkflowClicked={
                                                        onEditJobWorkflowClicked
                                                    }
                                                    onEmergencyClicked={
                                                        onEmergencyClicked
                                                    }
                                                    tenantSettings={
                                                        tenantSettings
                                                    }
                                                    strings={
                                                        strings
                                                    }
                                                    equipmentGroups={
                                                        equipmentGroups
                                                    }
                                                    onAssignmentFilterClicked={
                                                        onAssignmentFilterClicked
                                                    }
                                                />
                                                {/* <FontAwesomeIcon */}
                                                {/*    title="Remove all assignments for this job" */}
                                                {/*    icon={faMinusCircle} */}
                                                {/*    className="text-danger cursor-pointer" */}
                                                {/*    onClick={removeAllJobAssignments} */}
                                                {/* /> */}
                                            </div>
                                        </div>
                                    );
                                    // }
                                }
                            )}
                    </div>
                </div>
        );
    }
}

export default JobListingContainer;

